import ScienceIcon from "@material-design-icons/svg/round/science.svg?react";

export const LabsIcon: React.FC = () => {
  return <ScienceIcon />;
};
